import { AuthService, MenuService } from '../../services';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExtraOption, Menu } from '../../models';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mmg-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input() title: string = '';
  @Input() extraOptions: ExtraOption[] = [];
  @Input() languages: { [key: string]: any; } = { 'nl': { flag: 'nl', name: 'Nederlands' } };
  @Input() helpRoute: string = 'help';
  @Input() menuColor?: string;
  @Input() logoSrc?: string;

  @Output() selectedOption = new EventEmitter<string>();
  @Output() sidenavToggle = new EventEmitter();
  @Output() selectedLanguage = new EventEmitter<string>();

  readonly menu$: Observable<Menu[]>;

  selectedLang: string = '';
  availableLanguages: string[] = [];

  constructor(
    private readonly menuService: MenuService,
    private readonly authService: AuthService,
    private readonly translateService: TranslateService,
    private readonly router: Router,
  ) {
    this.menu$ = this.menuService.menu$;
  }

  ngOnInit(): void {
    this.menuService.load();
    this.availableLanguages = [...this.translateService.getLangs()];
    const currentUser = this.authService.getCurrentUser();
    this.selectedLang = currentUser?.language ?? this.translateService.currentLang;
  }

  select(option: string): void {
    this.selectedOption.emit(option);
  }

  logout(): void {
    this.authService.logout();
  }

  onToggleSidenav(): void {
    this.sidenavToggle.emit();
  }
  
  setLanguage(selectLang: string): void {
    this.selectedLang = selectLang;
    this.translateService.use(this.selectedLang);
    this.selectedLanguage.emit(selectLang);
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
  }

  help(): void {
    this.router.navigateByUrl(this.helpRoute);
  }

}